import { Create } from 'react-admin'
import FormInput from './FormInput'

const ProductCreate = () => {
  return (
    <Create redirect='list'>
      <FormInput />
    </Create>
  )
}

export default ProductCreate